import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../api";
import { useAuth } from "../App";

function PdfModal({ reciboId, onClose }) {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`/api/recibos/${reciboId}/pdf`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.blob())
      .then(blob => setPdfUrl(URL.createObjectURL(blob)));
  }, [reciboId]);

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.55)",
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", zIndex: 9999, padding: 20,
    }}>
      <div style={{ background: "white", borderRadius: 8, width: "100%", maxWidth: 900, height: "80vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,.3)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 20px", borderBottom: "1px solid var(--border)" }}>
          <span style={{ fontWeight: 600, color: "var(--navy)" }}>Vista previa del recibo</span>
          <button className="btn btn-sm" onClick={onClose}>Cerrar</button>
        </div>
        {pdfUrl
          ? <iframe src={pdfUrl} title="Recibo PDF" style={{ flex: 1, border: "none" }} />
          : <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center" }}><div className="spinner" /></div>
        }
      </div>
    </div>
  );
}

function ConfirmarFirmaModal({ recibo, onConfirm, onCancel, loading }) {
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.55)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 20,
    }}>
      <div className="card" style={{ maxWidth: 440, width: "100%" }}>
        <h3 style={{ color: "var(--navy)", marginBottom: 16 }}>Confirmar firma</h3>
        <p style={{ marginBottom: 8 }}>
          Estás por firmar tu recibo de <strong>{recibo.concepto}</strong> — período <strong>{recibo.periodo}</strong>.
        </p>
        <p style={{ marginBottom: 24, fontSize: 14, color: "var(--gray)" }}>
          Al confirmar, se registrará tu firma con fecha, hora, IP y dispositivo. Esta acción no se puede deshacer.
        </p>
        <div style={{ display: "flex", gap: 12 }}>
          <button className="btn btn-full" onClick={onCancel} disabled={loading}>Cancelar</button>
          <button className="btn btn-primary btn-full" onClick={onConfirm} disabled={loading}>
            {loading ? "Firmando..." : "Sí, firmar recibo"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function DashboardEmpleado() {
  const { auth } = useAuth();
  const [recibos, setRecibos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [pdfOpen, setPdfOpen] = useState(null);
  const [firmarRecibo, setFirmarRecibo] = useState(null);
  const [firmandoId, setFirmandoId] = useState(null);
  const [success, setSuccess] = useState("");

async function descargarPdf(reciboId, concepto, periodo, apellido) {
    const token = localStorage.getItem("token");
    const r = await fetch(`/api/recibos/${reciboId}/pdf`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
const periodoFormateado = periodo
  .replace("1ra quincena", "1Qna")
  .replace("2da quincena", "2Qna")
  .replace("Mensual", "Mens")
  .replace(/\s+/g, '-');
a.download = `FRICSA_${concepto}_${periodoFormateado}_${apellido}.pdf`;    a.click();
    URL.revokeObjectURL(url);
  }

  async function cargarRecibos() {
    setLoading(true);
    try {
      setRecibos(await api.misRecibos());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { cargarRecibos(); }, []);

  async function confirmarFirma() {
    setFirmandoId(firmarRecibo.id);
    try {
      await api.firmarRecibo(firmarRecibo.id);
      setFirmarRecibo(null);
      setSuccess("Recibo firmado correctamente. Recibirás un email de confirmación.");
      await cargarRecibos();
    } catch (e) {
      setError(e.message);
    } finally {
      setFirmandoId(null);
    }
  }

  const pendientes = recibos.filter(r => r.estado === "pendiente").length;

  return (
    <Layout>
      {pdfOpen && <PdfModal reciboId={pdfOpen} onClose={() => setPdfOpen(null)} />}
      {firmarRecibo && (
        <ConfirmarFirmaModal
          recibo={firmarRecibo}
          onConfirm={confirmarFirma}
          onCancel={() => setFirmarRecibo(null)}
          loading={!!firmandoId}
        />
      )}

      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: "var(--navy)" }}>
          Mis recibos
        </h1>
        <p style={{ color: "var(--gray)", marginTop: 4 }}>
          Hola, {auth?.user?.nombre} {auth?.user?.apellido}.
          {pendientes > 0 && (
            <span style={{ color: "var(--warning)", fontWeight: 600, marginLeft: 8 }}>
              Tenés {pendientes} recibo{pendientes > 1 ? "s" : ""} pendiente{pendientes > 1 ? "s" : ""} de firma.
            </span>
          )}
        </p>
      </div>

      {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}
      {success && <div className="alert alert-success" style={{ marginBottom: 16 }}>{success}</div>}

      {loading ? (
        <div style={{ padding: 60, textAlign: "center" }}><div className="spinner" /></div>
      ) : recibos.length === 0 ? (
        <div className="card" style={{ textAlign: "center", padding: 48, color: "var(--gray)" }}>
          No tenés recibos disponibles todavía.
        </div>
      ) : (
        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          <table>
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Período</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {recibos.map(r => (
                <tr key={r.id}>
                  <td style={{ fontWeight: 500 }}>{r.concepto}</td>
                  <td>{r.periodo}</td>
                  <td>
                    <span className={`badge badge-${r.estado}`}>
                      {r.estado === "pendiente" ? "Pendiente de firma" : "Firmado"}
                    </span>
                  </td>
                  <td>
<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
  {r.estado === "pendiente" ? (
    <div style={{ display: "flex", gap: 6 }}>
      <button className="btn btn-sm" onClick={() => setPdfOpen(r.id)}>
        Ver
      </button>
      <button className="btn btn-primary btn-sm" onClick={() => setFirmarRecibo(r)}>
        Firmar
      </button>
    </div>
  ) : (
    <button className="btn btn-sm" style={{ width: "100%" }} onClick={() => setPdfOpen(r.id)}>
      Ver
    </button>
  )}
  <button
    className="btn btn-sm"
    style={{ width: "100%" }}
    onClick={() => descargarPdf(r.id, r.concepto, r.periodo, auth?.user?.apellido)}
  >
    Descargar
  </button>
</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
